import { render, staticRenderFns } from "./VehiclesTableComponent.vue?vue&type=template&id=ed2387a0&scoped=true&"
import script from "./VehiclesTableComponent.vue?vue&type=script&lang=js&"
export * from "./VehiclesTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2387a0",
  null
  
)

export default component.exports